import React from "react";
import ReactTagInput from "@pathofdev/react-tag-input";
import "@pathofdev/react-tag-input/build/index.css";
import "./InputTags.scss";

function InputTags(props) {
  return (
    <>
      <div className="TagInputField">
        <ReactTagInput
          placeholder={props.placeholder}
          tags={props.tags || []}
          removeOnBackspace={true}
          onChange={props.onChange}
          readOnly={props?.readOnly===true?true:false}
        />
      </div>
    </>
  );
}

export default InputTags;
